import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import { withRouter } from "react-router-dom";
import { SearchOutlined } from '@ant-design/icons';
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'
import {
  Table,
  DatePicker,
  Button,
  Input,
  Select,
  message,
  Modal,
  Form,
  Checkbox,
} from "antd";
const { TextArea } = Input;
import { getFlowList, flowAction, exportFile, deleteAction, getLabelList } from "../../actions/flow";
import closeSvg from "../../assets/svg/delete.svg";
import axios from "axios";

const { RangePicker } = DatePicker;
const { Option } = Select;

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "64px",
      padding: "24px 24px 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      background: "#fff",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
    },
    tableContainer: {
      width: "100%",
      "& .ant-table-cell-row-hover": {
        background: "#f0fbff !important",
      },
      "& td.ant-table-column-sort": {
        background: "#f0fbff !important",
      },
      
    },
    link: {
      color: "#0F25D1",
    },
    statusRed: {
      color: "#FF6100",
    },
    statusGreen: {
      color: "#39C07A",
    },
    statusGray: {
      color: "#999",
    },
    textarea: {
      padding: "8px 10px",
      outline: "none",
      border: "1px solid #ccc !important",
      minHeight: "60px !important",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    select: {
      width: '100%'
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
  };
};

class WorkFlow extends Component {
  constructor(props) {
    super(props);
  }

  formRef = React.createRef();

  state = {
    tabIndex: 2,
    loading: true,
    columns: [],
    data: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      lable_category: undefined,
      regulation_file_type: undefined,
      is_evaluation_sheet_needed: undefined,
      is_gap_analyseis: undefined,
      is_training_session: undefined,
      labelName: undefined,
      status: ''
    },
    labelObj: {
      lable_category: '文件类型',
      regulation_file_type: '法规类型',
      is_evaluation_sheet_needed: '是否需填写评估表',
      is_gap_analyseis: '是否Gap Analysis',
      is_training_session: '是否Training Session',
      labelName: '分类标签',
      status: '流程状态'
    },
    sortObj: {},
    searchType: "需要审批",
    confirmModal: false,
    page: {
      PageNo: 1,
      PageSize: 10,
    },
    rowSelection: {
      onChange: (selectedRowKeys) => {
        let newRowSelection = this.state.rowSelection;
        newRowSelection.selectedRowKeys = selectedRowKeys;
        this.setState({
          rowSelection: newRowSelection,
        });
      },
    },
    total: 0,
    paginationObj: {
      showSizeChanger: true,
      total: 0,
      showTotal: (total, range) => {
        return "共有" + this.state.paginationObj.total + "条数据";
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize);
      },
    },
    filteredInfo: null,
    regulationFileTypeList: [],
    labelList: [],
    fileTypeList: [
      {
        ID: '法规',
        Name: '法规'
      },
      {
        ID: '标准',
        Name: '标准'
      },
      {
        ID: '指导原则',
        Name: '指导原则'
      },
    ],
    statusList: [
      {
        ID: '是',
        Name: '是'
      },
      {
        ID: '否',
        Name: '否'
      },
    ]
  };

  componentDidMount() {
    this.initDict()
    this.getColumns();
    this.initData();
    let form = {
      ...this.state.defaultForm
    }
    this.setState({
      form
    })
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })
  }

  
  initDict = (keyword, reset) => {
    getLabelList({
      file_category: keyword || '法规,标准,指导原则'
    }).then(res => {
      let list = res.results || []
      this.setState({
        labelList: list.map(v => {
          return {
            ID: v,
            Name: v
          }
        })
      })
    })
  }

  resetForm = () => {
    this.setState({
      form: {
        lable_category: undefined,
        regulation_file_type: undefined,
        is_evaluation_sheet_needed: undefined,
        is_gap_analyseis: undefined,
        is_training_session: undefined,
        labelName: '',
        status: ''
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: form[key],
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = form[key]
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  initData = () => {
    let param = {}
    // if (this.state.tabIndex === 3) {
      let form = this.state.form
      param = {
        file_type: form.lable_category ? form.lable_category : '',
        regulation_file_type: form.regulation_file_type ? form.regulation_file_type : '',
        lable: form.labelName ? form.labelName : '',
        is_evaluation_sheet_needed: form.is_evaluation_sheet_needed ? form.is_evaluation_sheet_needed : '',
        is_gap_analyseis: form.is_gap_analyseis ? form.is_gap_analyseis : '',
        is_training_session: form.is_training_session ? form.is_training_session : '',
        status: form.status ? form.status : '',
      }
    // } 
    getFlowList({
      page: this.state.page.PageNo,
      pageSize: this.state.page.PageSize,
      action_type: this.state.searchType,
      ...param
    }).then((res) => {
      if (res.message && res.message.length) {
        let newPaginationObj = this.state.paginationObj;
        newPaginationObj.total = res.totall;
        let list = (res.regulationFileTypeOptions || []).map(v => {
          return {
            ID: v,
            Name: v
          }
        })
        this.setState(
          {
            data: res.message.map((v) => {
              v.key = v.id;
              return v;
            }),
            regulationFileTypeList: list,
            paginationObj: newPaginationObj,
            loading: false,
          },
          () => {
            this.getColumns();
          }
        );
      } else {
        this.setState({
          loading: false,
          data: [],
        });
      }
    });
  };

  previewFile = (url) => {
    localStorage.setItem('previewUrl', url);
    const w = window.open("ablut:blank");
    w.location.href = "/preview";
  };

  getColumns = () => {
    let classes = this.props.classes;
    let columns = []
    if (this.state.tabIndex === 3) {
      columns = [
        {
          title: "序号",
          dataIndex: "sort",
          key: "sort",
          width: 70,
          align: "center",
          render: (_, record, index) => {
            return (
              index + 1 + (this.state.page.PageNo - 1) * this.state.page.PageSize
            );
          },
        },
        {
          title: "文件名称",
          dataIndex: "file_name",
          key: "file_name",
          width: 300,
          align: "center",
          render: (_, record) => (
            <a  onClick={() => this.previewFile(record.file_url)}>
              {record.file_name}
            </a>
          ),
        },
        {
          title: "文件类型",
          dataIndex: "lable_category",
          key: "lable_category",
          width: 120,
          align: "center",
          render: (_, record) => {
            let lables = JSON.parse(record.lable_info);
            let name = "";
            for (let key in lables) {
              name = key;
            }
            return name;
          },
        },
        {
          title: "分类标签",
          dataIndex: "labelName",
          width: 160,
          key: "labelName",
          align: "center",
          render: (_, record) => {
            let lables = JSON.parse(record.lable_info);
            let name = "";
            for (let key in lables) {
              name = lables[key].join();
            }
            return name;
          },
        },
        {
          title: "发起日期",
          dataIndex: "date_create_time",
          key: "date_create_time",
          width: 130,
          align: "center",
          render: (_, record) => {
            return record.date_create_time.substring(0, 10);
          },
        },
      ];
      if (this.state.form.lable_category === '法规') {
        columns.splice(3, 0 , {
          title: "法规类型",
          dataIndex: "regulation_file_type",
          key: "regulation_file_type",
          width: 120,
          align: "center"
        })
      }
    } else {
      columns = [
        {
          title: "序号",
          dataIndex: "sort",
          key: "sort",
          width: 70,
          align: "center",
          render: (_, record, index) => {
            return (
              index + 1 + (this.state.page.PageNo - 1) * this.state.page.PageSize
            );
          },
        },
        {
          title: "文件名称",
          dataIndex: "file_name",
          key: "file_name",
          width: 300,
          align: "center",
          render: (_, record) => (
            <a  onClick={() => this.previewFile(record.file_url)}>
              {record.file_name}
            </a>
          ),
        },
        {
          title: "文件类型",
          dataIndex: "lable_category",
          key: "lable_category",
          width: 120,
          align: "center",
          render: (_, record) => {
            let lables = JSON.parse(record.lable_info);
            let name = "";
            for (let key in lables) {
              name = key;
            }
            return name;
          },
        },
        {
          title: "分类标签",
          dataIndex: "labelName",
          width: 160,
          key: "labelName",
          align: "center",
          render: (_, record) => {
            let lables = JSON.parse(record.lable_info);
            let name = "";
            for (let key in lables) {
              name = lables[key].join();
            }
            return name;
          },
        },
        {
          title: "发起日期",
          dataIndex: "date_create_time",
          key: "date_create_time",
          width: 130,
          align: "center",
          render: (_, record) => {
            return record.date_create_time.substring(0, 10);
          },
        },
      ];
    }
    //
    if (this.state.tabIndex === 0) {
      columns = columns.concat([
        {
          title: "流程状态",
          dataIndex: "status",
          key: "status",
          width: 120,
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "action",
          width: 120,
          key: "action",
          align: "center",
          render: (_, record) => (
            <a
              className={classes.link}
              onClick={() => this.handleCancel(record)}
            >
              取消
            </a>
          ),
        },
      ]);
    } else if (this.state.tabIndex === 1) {
      columns = columns.concat([
        {
          title: "是否需填写评估表",
          dataIndex: "is_evaluation_sheet_needed",
          key: "is_evaluation_sheet_needed",
          width: 160,
          align: "center",
          render: (_, record) => {
            return record.is_evaluation_sheet_needed ? "是" : "否";
          },
        },
        {
          title: "是否Gap Analysis",
          dataIndex: "is_gap_analyseis",
          key: "is_gap_analyseis",
          width: 150,
          align: "center",
          render: (_, record) => {
            return record.is_gap_analyseis ? "是" : "否";
          },
        },
        {
          title: "是否Training Session",
          dataIndex: "is_training_session",
          key: "is_training_session",
          width: 170,
          align: "center",
          render: (_, record) => {
            return record.is_training_session ? "是" : "否";
          },
        },
        {
          title: "备注",
          dataIndex: "comments",
          key: "comments",
          width: 180,
          align: "center",
        },
        {
          title: "流程状态",
          dataIndex: "status",
          key: "status",
          width: 110,
          align: "center",
        },
        {
          title: "审批人",
          dataIndex: "approve_user",
          key: "approve_user",
          width: 120,
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "action",
          width: 120,
          key: "action",
          align: "center",
          render: (_, record) => (
            <a
              className={classes.link}
              onClick={() => this.handleDeleteTag(record)}
            >
              删除标签
            </a>
          ),
        },
      ]);
    } else if (this.state.tabIndex === 2) {
      columns = columns.concat([
        {
          title: "发起人",
          dataIndex: "username",
          key: "username",
          width: 130,
          align: "center",
        },
        {
          title: "流程状态",
          dataIndex: "status",
          key: "status",
          width: 120,
          align: "center",
        },
        {
          title: "是否需填写评估表",
          dataIndex: "is_evaluation_sheet_needed",
          key: "is_evaluation_sheet_needed",
          width: 160,
          align: "center",
          render: (_, record, i) => (
            <Checkbox
              checked={record.is_evaluation_sheet_needed}
              onChange={(e) => this.changeEvaluationChcekbox(i)}
            />
          ),
        },
        {
          title: "是否Gap Analysis",
          dataIndex: "is_gap_analyseis",
          key: "is_gap_analyseis",
          width: 160,
          align: "center",
          render: (_, record, i) => (
            <Checkbox
              checked={record.is_gap_analyseis}
              onChange={(e) => this.changeGapChcekbox(i)}
            />
          ),
        },
        {
          title: "是否Training Session",
          dataIndex: "is_training_session",
          key: "is_training_session",
          width: 180,
          align: "center",
          render: (_, record, i) => (
            <Checkbox
              checked={record.is_training_session}
              onChange={() => this.changeTraChcekbox(i)}
            />
          ),
        },
        {
          title: "备注",
          dataIndex: "comments",
          key: "comments",
          width: 180,
          align: "center",
          render: (_, record, i) => (
            <TextareaAutosize
              className={classes.textarea}
              value={record.comments}
              onChange={(e) => this.changeComments(e, i)}
            />
          ),
        },
      ]);
    } else if (this.state.tabIndex === 3) {
      columns = columns.concat([
        {
          title: "是否需填写评估表",
          dataIndex: "is_evaluation_sheet_needed",
          key: "is_evaluation_sheet_needed",
          width: 160,
          align: "center",
          render: (_, record) => {
            return record.is_evaluation_sheet_needed ? "是" : "否";
          },
        },
        {
          title: "是否Gap Analysis",
          dataIndex: "is_gap_analyseis",
          key: "is_gap_analyseis",
          width: 150,
          align: "center",
          render: (_, record) => {
            return record.is_gap_analyseis ? "是" : "否";
          },
        },
        {
          title: "是否Training Session",
          dataIndex: "is_training_session",
          key: "is_training_session",
          width: 170,
          align: "center",
          render: (_, record) => {
            return record.is_training_session ? "是" : "否";
          },
        },
        {
          title: "备注",
          dataIndex: "comments",
          key: "comments",
          width: 180,
          align: "center",
        },
        {
          title: "流程状态",
          dataIndex: "status",
          key: "status",
          width: 110,
          align: "center",
        },
        {
          title: "审批人",
          dataIndex: "approve_user",
          key: "approve_user",
          width: 120,
          align: "center",
        },
      ]);
    } 
    this.setState({
      columns: columns,
    });
  };

  changeEvaluationChcekbox = (i) => {
    let data = [].concat(this.state.data);
    data[i].is_evaluation_sheet_needed = !data[i].is_evaluation_sheet_needed;
    this.setState(
      {
        data: data,
      },
      () => {
        this.getColumns();
      }
    );
  };

  changeGapChcekbox = (i) => {
    let data = [].concat(this.state.data);
    data[i].is_gap_analyseis = !data[i].is_gap_analyseis;
    this.setState(
      {
        data: data,
      },
      () => {
        this.getColumns();
      }
    );
  };

  changeTraChcekbox = (i) => {
    let data = [].concat(this.state.data);
    data[i].is_training_session = !data[i].is_training_session;
    this.setState(
      {
        data: data,
      },
      () => {
        this.getColumns();
      }
    );
  };

  changeComments = (e, i) => {
    let content = e.target.value;
    let data = [].concat(this.state.data);
    data[i].comments = content;
    this.setState(
      {
        data: data,
      },
      () => {
        this.getColumns();
      }
    );
  };

  handleDownload = () => {
    let ids = this.state.rowSelection.selectedRowKeys;
    if (!ids || ids.length == 0) {
      message.warning("请勾选数据");
      return;
    }
    let info = this.state.data.filter((v) => {
      return ids.includes(v.id);
    });
    info.forEach((v) => {
      let url = v.file_url;
      if (url) {
        let fileName = v.file_name;
        this.downloadFile(url, fileName);
      }
    });
  };

  handleSearch = (key, value, confirm) => {
    let newForm = this.state.form
  
    if (value instanceof Array && value.length > 1) {
      newForm[key] = value.join(';')
    } else {
      newForm[key] = value
    }

    this.setState({
      form: newForm,
      loading: true
    }, () => {
      this.initData()
    })
    confirm()
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleReset = (clearFilters) => {
    clearFilters()
  }

  handleSort = () => {}

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  downloadFile = (url, fileName) => {
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  };

  handleCancel = (data) => {
    flowAction({
      action_name: "取消",
      ticket_info: JSON.stringify([
        {
          ticket_id: data.id,
          comments: v.comments,
          is_gap_analysis: "True",
          is_training_session: false,
          is_evaluation_sheet_needed: "false",
        },
      ]),
    }).then((res) => {
      if (res.isOperateSuccess) {
        message.success("取消成功");
        this.initData();
      } else {
        message.error(res.message);
      }
    });
  };

  handleDeleteTag = (data) => {
    Modal.confirm({
      title: '提示',
      content: '确认删除？',
      onOk: () => {
        this.setState({loading: true})
        deleteAction({
          id: data.id
        }).then((res) => {
          message.success("删除标签成功");
          this.initData();
        }).catch(() => {
          this.setState({loading: false})
        })
      }
    })
  };

  handleAgree = () => {
    let ids = this.state.rowSelection.selectedRowKeys;
    if (!ids || ids.length == 0) {
      message.warning("请勾选数据");
      return;
    }
    let info = this.state.data.filter((v) => {
      return ids.includes(v.id);
    });
    flowAction({
      action_name: "审批通过",
      ticket_info: JSON.stringify(
        info.map((v) => {
          return {
            ticket_id: v.id,
            comments: v.comments,
            is_gap_analysis: v.is_gap_analyseis ? "True" : "false",
            is_training_session: v.is_training_session ? "True" : "false",
            is_evaluation_sheet_needed: v.is_evaluation_sheet_needed
              ? "True"
              : "false",
          };
        })
      ),
    }).then((res) => {
      if (res.isOperateSuccess) {
        message.success("审批成功");
        this.setState({
          confirmModal: false,
        });
        this.initData();
      } else {
        message.error(res.message);
      }
    });
  };

  handleReject = () => {
    let ids = this.state.rowSelection.selectedRowKeys;
    if (!ids || ids.length == 0) {
      message.warning("请勾选数据");
      return;
    }
    let info = this.state.data.filter((v) => {
      return ids.includes(v.id);
    });
    flowAction({
      action_name: "审批不通过",
      ticket_info: JSON.stringify(
        info.map((v) => {
          return {
            ticket_id: v.id,
            comments: v.comments,
            is_gap_analysis: v.is_gap_analyseis ? "True" : "false",
            is_training_session: v.is_training_session ? "True" : "false",
            is_evaluation_sheet_needed: v.is_evaluation_sheet_needed
              ? "True"
              : "false",
          };
        })
      ),
    }).then((res) => {
      if (res.isOperateSuccess) {
        message.success("审批成功");
        this.initData();
      } else {
        message.error(res.message);
      }
    });
  };

  handleExport = () => {
    exportFile().then((res) => {
      let dateOrigin = new Date();
      let dateString =
        dateOrigin.getFullYear() +
        "-" +
        (dateOrigin.getMonth() + 1) +
        "-" +
        dateOrigin.getDate() +
        "-" +
        dateOrigin.getHours() +
        "-" +
        dateOrigin.getMinutes() +
        "-" +
        dateOrigin.getSeconds();
      let fileName = "DCA文件信息" + dateString + ".xlsx";
      const blob = new Blob([res], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let a = document.createElement("a");
      a.download = fileName;
      let URL = window.URL || window.webkitURL;
      a.href = URL.createObjectURL(blob);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  };

  pageChange = (page, pageSize) => {
    if (
      page == this.state.page.PageNo &&
      pageSize == this.state.page.PageSize
    ) {
      return;
    }
    this.setState(
      {
        page: {
          PageNo: page,
          PageSize: pageSize,
        },
        loading: true,
      },
      () => this.initData()
    );
  };

  changeTab = (index) => {
    let rowSelection = false;
    if (index === 2 || index == 3) {
      rowSelection = {
        onChange: (selectedRowKeys) => {
          let newRowSelection = this.state.rowSelection;
          newRowSelection.selectedRowKeys = selectedRowKeys;
          this.setState({
            rowSelection: newRowSelection,
          });
        },
      };
    }
    this.setState(
      {
        loading: true,
        tabIndex: index,
        rowSelection: rowSelection,
        searchType:
          index == 2
            ? "需要审批"
            : index == 0
            ? "未完成"
            : index == 1
            ? "已完成"
            : "批量下载",
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    if (key === 'lable_category') {
      this.initDict(value)
      form.labelName = undefined
      form.regulation_file_type = undefined
    }
    this.setState({
      form: form
    }, () => {
      if (key === 'lable_category') {
        this.getColumns()
      }
    })

  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">文件类型</div>
              <div className="form-input">
                <Select
                  allowClear
                  placeholder="请选择"
                  value={this.state.form.lable_category}
                  onChange={(e) => this.onChangeForm(e, 'lable_category')} 
                >
                  {
                    this.state.fileTypeList.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            </div>
            {
              this.state.form.lable_category === '法规' &&
              <div className="form-item">
                <div className="form-label">法规类型</div>
                <div className="form-input">
                  <Select
                    allowClear
                    placeholder="请选择"
                    value={this.state.form.regulation_file_type}
                    onChange={(e) => this.onChangeForm(e, 'regulation_file_type')} 
                  >
                    {
                      this.state.regulationFileTypeList.map((v, i) => {
                        return (
                          <Option value={v.ID} key={i}>{v.Name}</Option>
                        )
                      })
                    }
                  </Select>
                </div>
              </div>
            }

            <div className="form-item">
              <div className="form-label">分类标签</div>
              <div className="form-input">
                <Select
                  allowClear
                  placeholder="请选择"
                  value={this.state.form.labelName}
                  onChange={(e) => this.onChangeForm(e, 'labelName')} 
                >
                  {
                    this.state.labelList.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            </div>

            <div className="form-item">
              <div className="form-label">流程状态</div>
              <Input  value={this.state.form.status}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'status')} 
                placeholder="请输入流程状态"/>
            </div>
            
            <div className="form-item">
              <div className="form-label">是否需填写评估表</div>
              <div className="form-input">
                <Select
                  allowClear
                  placeholder="请选择"
                  value={this.state.form.is_evaluation_sheet_needed}
                  onChange={(e) => this.onChangeForm(e, 'is_evaluation_sheet_needed')} 
                >
                  {
                    this.state.statusList.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            </div>
            
            <div className="form-item">
              <div className="form-label">是否Gap Analysis</div>
              <div className="form-input">
                <Select
                  allowClear
                  placeholder="请选择"
                  value={this.state.form.is_gap_analyseis}
                  onChange={(e) => this.onChangeForm(e, 'is_gap_analyseis')} 
                >
                  {
                    this.state.statusList.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            </div>

            <div className="form-item">
              <div className="form-label">是否Training Session</div>
              <div className="form-input">
                <Select
                  allowClear
                  placeholder="请选择"
                  value={this.state.form.is_training_session}
                  onChange={(e) => this.onChangeForm(e, 'is_training_session')} 
                >
                  {
                    this.state.statusList.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            </div>

          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>
        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">工作流任务</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <div className="main-top">
              <div>
                <span
                  onClick={() => this.changeTab(2)}
                  className={[
                    "main-tab",
                    this.state.tabIndex == 2 ? "active" : "",
                  ].join(" ")}
                >
                  需要审批的分类流程
                </span>
                <span
                  onClick={() => this.changeTab(0)}
                  className={[
                    "main-tab",
                    this.state.tabIndex == 0 ? "active" : "",
                  ].join(" ")}
                >
                  未完成的分类流程
                </span>
                <span
                  onClick={() => this.changeTab(1)}
                  className={[
                    "main-tab",
                    this.state.tabIndex == 1 ? "active" : "",
                  ].join(" ")}
                >
                  已完成的分类流程
                </span>
                <span
                  onClick={() => this.changeTab(3)}
                  className={[
                    "main-tab",
                    this.state.tabIndex == 3 ? "active" : "",
                  ].join(" ")}
                >
                  批量下载
                </span>
              </div>
              {(this.state.tabIndex == 1 ||
                this.state.tabIndex == 2 ||
                this.state.tabIndex == 3) && (
                <Grid className={classes.tableBtn}>
                  {this.state.tabIndex == 1 ? (
                    <Button type="primary" onClick={this.handleExport}>
                      导出Excel
                    </Button>
                  ) : this.state.tabIndex == 2 ? (
                    <>
                      <Button type="primary" onClick={this.handleAgree}>
                        通过
                      </Button>
                      <Button  ghost onClick={this.handleReject}>
                        拒绝
                      </Button>
                    </>
                  ) : (
                    <Button type="primary" onClick={this.handleDownload}>
                      下载
                    </Button>
                  )}
                </Grid>
              )}
            </div>

            <Grid container className={classes.container} id="tableContainer">
              <Table
                rowSelection={this.state.rowSelection}
                className={classes.tableContainer}
                columns={this.state.columns}
                loading={this.state.loading}
                onChange={this.handleChange} 
                dataSource={this.state.data}
                pagination={this.state.paginationObj}
                bordered
              />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(WorkFlow));
